import gql from 'graphql-tag';

import type { LongFormDraft } from 'src/data/longForm/types';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationCreateLongFormFormatCompliantDraftArgs } from 'src/types/backend';

import { FRAGMENT_LONG_FORM_BUILDER_DRAFT } from './schema';

const MUTATION = gql`
  mutation CreateLongFormFormatCompliantDraft($id: ID!) {
    createLongFormFormatCompliantDraft(id: $id) {
      ...LongFormBuilderDraft
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
`;

type Variables = BackendMutationCreateLongFormFormatCompliantDraftArgs;
type Result = LongFormDraft;

export const createLongFormFormatCompliantDraft = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
